export const bookSlot = (details) => ({
    type: 'BOOK_SLOT',
    details
});